import { render, staticRenderFns } from "./LogoElement.vue?vue&type=template&id=13359f5a&scoped=true&"
import script from "./LogoElement.vue?vue&type=script&lang=js&"
export * from "./LogoElement.vue?vue&type=script&lang=js&"
import style0 from "./LogoElement.vue?vue&type=style&index=0&id=13359f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13359f5a",
  null
  
)

export default component.exports